import { toast } from "sonner";
import axios from "../axios";
import { useState } from "react";

export const useGetBrands = () => {
  const [loading, setLoading] = useState(false);
  const [brands, setBrands] = useState([]);
  const [loadingAcheivements, setLoadingAcheivements] = useState(false);
  const [loadingRewards, setLoadingRewards] = useState(false);
  const [leaderboardData, setLeadboardData] = useState({});
  const [rewardsData, setRewardsData] = useState({});

  const getBrands = async (token) => {
    setLoading(true);
    try {
      const res = await axios.get("/audiences/brands", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        setLoading(false);
        setBrands(res?.data?.data);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  const getBrandLeadBoard = async (brandId, type) => {
    try {
      setLoadingAcheivements(true);
      const res = await axios.get(
        `/audiences/brand-leaderboard/${brandId}?filter=${type}`
      );

      if (res.status === 200) {
        setLeadboardData(res?.data);
        setLoadingAcheivements(false);
      }
    } catch (err) {
      setLoadingAcheivements(false);
      toast.error(err?.response?.data?.message);
    }
  };

  const getUserBrandRewards = async (brandId) => {
    try {
      setLoadingRewards(true);
      const res = await axios.get(`/audiences/brand/${brandId}/achievements`);

      if (res.status === 200) {
        setRewardsData(res?.data?.data);
        setLoadingRewards(false);
      }
    } catch (err) {
      setLoadingRewards(false);
      toast.error(err?.response?.data?.message);
    }
  };

  return {
    getBrands,
    brands,
    setBrands,
    loading,
    setLoading,
    leaderboardData,
    loadingAcheivements,
    getBrandLeadBoard,
    getUserBrandRewards,
    loadingRewards,
    rewardsData,
  };
};
